import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, OnInit, QueryList } from '@angular/core';
import { DTO } from '../../../app/core/models/dto';
import { environment } from '../../../environments/environment';
import { iocCountryMap } from '../../shared/const';
var PromotionLeaderboardViewComponent = /** @class */ (function () {
    function PromotionLeaderboardViewComponent(leaderboardService, commonService) {
        this.leaderboardService = leaderboardService;
        this.commonService = commonService;
        this.progress = false;
        this.isMaintenance = false;
        this.isScrolling = false;
        this.isBountyKOPromotion = false;
        this.isRefreshable = true;
        this.countryCodes = {};
        this.leaderboardTypes = DTO.Enums.LeaderboardType;
        this.environment = environment.env;
        this.countryFlagMap = new Map([
            ['UA', { RU: 'RU_WB' }],
            ['CN', { TW: 'CN' }],
            ['LB', { IL: 'CY' }]
        ]);
        this.wsopCountryFlagMap = new Map([
            ['UA', { RU: 'RU_WB' }],
            ['LB', { IL: 'IOC' }],
        ]);
        this.wsopPrizeCustomList = {
            PROD: [43692],
            TEST: [27406]
        };
    }
    Object.defineProperty(PromotionLeaderboardViewComponent.prototype, "isMobile", {
        get: function () {
            return navigator.userAgent.match(/Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PromotionLeaderboardViewComponent.prototype, "isWsopPrizeCustom", {
        get: function () {
            var env = this.environment !== 'PROD' ? 'TEST' : this.environment;
            return this.wsopPrizeCustomList[env].indexOf(Number(this.promotionId)) > -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PromotionLeaderboardViewComponent.prototype, "isChase", {
        get: function () {
            return [DTO.Enums.PromotionType.CHASE, DTO.Enums.PromotionType.TOURNAMENT_LEADERBOARD_CHASE].indexOf(this.type) !== -1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PromotionLeaderboardViewComponent.prototype, "isTournamentLeaderBoard", {
        get: function () {
            return this.type === DTO.Enums.PromotionType.TOURNAMENT_LEADERBOARD;
        },
        enumerable: true,
        configurable: true
    });
    PromotionLeaderboardViewComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.load()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PromotionLeaderboardViewComponent.prototype.ngAfterViewInit = function () {
        this.listScrollToView(this.myRankMarking);
        this.listScrollToView(this.runningPrizeLevelMarking);
    };
    PromotionLeaderboardViewComponent.prototype.listScrollToView = function (scrollTargetElements) {
        scrollTargetElements.changes.subscribe(function () {
            scrollTargetElements.toArray().forEach(function (el) {
                if (el.nativeElement.classList.contains('myRank')) {
                    el.nativeElement.scrollIntoView({ behavior: 'smooth' });
                }
            });
        });
    };
    PromotionLeaderboardViewComponent.prototype.load = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var promises, playersLimit;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.progress = true;
                        return [4 /*yield*/, this.checkMaintenance()];
                    case 1:
                        _a.sent();
                        if (this.isMaintenance) {
                            this.progress = false;
                            return [2 /*return*/];
                        }
                        promises = [this.getCountryCodes()];
                        if (!(DTO.Enums.LeaderboardType.WSOP === this.leaderboardType)) return [3 /*break*/, 2];
                        promises.push(this.getWsopNationalityRankingList());
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.getNumberOfPlayers()];
                    case 3:
                        playersLimit = _a.sent();
                        if (this.hideRank) {
                            promises.push(this.getPlayerRankingList(playersLimit));
                        }
                        else {
                            promises.push.apply(promises, tslib_1.__spread([
                                this.getMyInfo(),
                                this.getPlayerRankingList(playersLimit)
                            ]));
                        }
                        _a.label = 4;
                    case 4:
                        if (this.isChase) {
                            promises.push(this.getPrizePoolList());
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 5:
                        _a.sent();
                        this.countryCode = this.leaderboardService.countryCode;
                        this.progress = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    PromotionLeaderboardViewComponent.prototype.checkMaintenance = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenance, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.commonService.getMaintenance()];
                    case 1:
                        maintenance = _a.sent();
                        this.isMaintenance = maintenance !== 'OK';
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.isMaintenance = true;
                        console.error(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PromotionLeaderboardViewComponent.prototype.getCountryCodes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_2;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this.commonService.getCountryCodes()];
                    case 1:
                        _a.countryCodes = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _b.sent();
                        console.error(e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PromotionLeaderboardViewComponent.prototype.getMyInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var targetParams, _a, e_3;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        if (!this.nickname) {
                            this.myInfo = null;
                            return [2 /*return*/];
                        }
                        targetParams = {
                            promotionId: this.promotionId,
                            nickname: this.nickname,
                            brandId: this.brandId,
                            siteId: this.siteId
                        };
                        _a = this;
                        return [4 /*yield*/, this.leaderboardService.getMyInfo(targetParams, !this.prizeVisibility)];
                    case 1:
                        _a.myInfo = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _b.sent();
                        this.myInfo = null;
                        console.error(e_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PromotionLeaderboardViewComponent.prototype.getWsopNationalityRankingList = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, e_4;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.leaderboardService.getWsopNationalityLeaderboard(this.optInGroupName, 100)];
                    case 1:
                        result = _a.sent();
                        this.wsopNationalityRankingList = result.map(function (item) { return (tslib_1.__assign({}, item, { displayCountryId: _this.getDisplayCountryCode(_this.wsopCountryFlagMap, item.nationality), displayIocCountryId: iocCountryMap.has(item.nationality) ? iocCountryMap.get(item.nationality) : item.nationality, displayPrize: _this.getDisplayPrizeForWsopNationalityRanking(item.prize) })); });
                        this.isScrolling = this.wsopNationalityRankingList.length > 10 && !this.isMobile;
                        return [3 /*break*/, 3];
                    case 2:
                        e_4 = _a.sent();
                        console.log('exception!!', e_4);
                        this.wsopNationalityRankingList = [];
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PromotionLeaderboardViewComponent.prototype.getDisplayPrizeForWsopNationalityRanking = function (prizeValue) {
        if (!prizeValue) {
            return '-';
        }
        var prize = prizeValue.split('|');
        if (this.onlyCoin) {
            return 1 < prize.length ? prize[1] : prize[0];
        }
        else {
            return prize[0];
        }
    };
    PromotionLeaderboardViewComponent.prototype.getPlayerRankingList = function (limit) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ret, e_5;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.leaderboardService.getRankingPlayerList({
                                promotionId: this.promotionId,
                                nickname: this.nickname
                            }, limit, !this.prizeVisibility)];
                    case 1:
                        ret = _a.sent();
                        this.rankingList = (this.isTournamentLeaderBoard ? ret : ret.filter(function (row) { return row.isCorrect; })).map(function (row) { return (tslib_1.__assign({}, row, { displayCountryId: _this.getDisplayCountryCode(_this.countryFlagMap, row.countryId) })); });
                        this.isScrolling = this.rankingList.length > 10 && !this.isMobile;
                        return [3 /*break*/, 3];
                    case 2:
                        e_5 = _a.sent();
                        this.rankingList = [];
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PromotionLeaderboardViewComponent.prototype.getDisplayCountryCode = function (countryFlagMap, countryId) {
        if (!countryFlagMap.has(this.leaderboardService.countryCode)) {
            return countryId;
        }
        var flagMap = countryFlagMap.get(this.leaderboardService.countryCode);
        return Object.prototype.hasOwnProperty.call(flagMap, countryId) ? flagMap[countryId] : countryId;
    };
    PromotionLeaderboardViewComponent.prototype.getPrizePoolList = function (limit) {
        if (limit === void 0) { limit = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var prizePoolList, selectedPrizePool_1, selectedLevel, rankingLimit, e_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.leaderboardService.getPrizePoolList({ promotionId: this.promotionId })];
                    case 1:
                        prizePoolList = _a.sent();
                        selectedPrizePool_1 = prizePoolList.find(function (prizePool) { return prizePool.winners !== prizePool.maxWinners; }) || prizePoolList[prizePoolList.length - 1];
                        if (!!selectedPrizePool_1) {
                            selectedPrizePool_1.isRunning = true;
                        }
                        this.prizePoolList = prizePoolList;
                        selectedLevel = selectedPrizePool_1.level;
                        rankingLimit = ((selectedLevel === 1 ?
                            selectedPrizePool_1
                            : prizePoolList.find(function (prizePool) { return prizePool.level === selectedPrizePool_1.level - 1; })) || {}).maxWinners || 0;
                        return [4 /*yield*/, this.getPlayerRankingList(limit ? limit : Math.max(rankingLimit, 10))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_6 = _a.sent();
                        this.prizePoolList = [];
                        console.error(e_6);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PromotionLeaderboardViewComponent.prototype.getNumberOfPlayers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var promotionDetail, description, e_7;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.leaderboardService.getPromotionType(this.promotionId)];
                    case 1:
                        promotionDetail = _a.sent();
                        if (!promotionDetail['description']) {
                            return [2 /*return*/, 250];
                        }
                        description = JSON.parse(promotionDetail['description']);
                        this.type = promotionDetail.type;
                        this.isBountyKOPromotion = promotionDetail['isBountyKOPromotion'] ? promotionDetail['isBountyKOPromotion'] : false;
                        return [2 /*return*/, !!description.displayedPlayers ? description.displayedPlayers : 250];
                    case 2:
                        e_7 = _a.sent();
                        console.error(e_7);
                        return [2 /*return*/, 250];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PromotionLeaderboardViewComponent.prototype.refresh = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requestTimer, DELAY_SECOND;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        requestTimer = null;
                        DELAY_SECOND = 5000;
                        requestTimer = setTimeout(function () {
                            _this.isRefreshable = true;
                            clearTimeout(requestTimer);
                        }, DELAY_SECOND);
                        return [4 /*yield*/, this.load()];
                    case 1:
                        _a.sent();
                        this.isRefreshable = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    return PromotionLeaderboardViewComponent;
}());
export { PromotionLeaderboardViewComponent };
